export default __webpack_public_path__ + "static/media/iconArrow.15dff4fe.svg";